// extracted by mini-css-extract-plugin
export default {"not-found":"NotFoundPage_not-found__4sePW","not-found__title":"NotFoundPage_not-found__title__QncZ+","not-found__message":"NotFoundPage_not-found__message__8MGv6"};